<template>
  <div class="container-fluid partner-payment-platform">
    <h3
      style="font-size: 19px;
    font-weight: bold; margin-bottom: 0;"
    >
      API-Billing
    </h3>
    <hr style="margin-top: 0;" />
    <!-- Card Button -->
    <div class="buttons-row">
      <!-- 1 -->
      <div>
        <CardButton
          title="Basic"
          description="Get Started with our APIs"
          price="#0"
          buttonText="Current Plan"
          :features="['Low Rate limit', 'Basic Support']"
          :isActive="true"
          @onCallFunc="() => renderFunction('Free')"
        />
      </div>
      <!-- 2 -->
      <div>
        <CardButton
          title="On Demand"
          description="Scale up and pay as you go"
          price="Pay per Token"
          buttonText="Coming soon"
          :features="['High Rate limit', 'Priority Support']"
          :isActive="currentButton === 'On Demand'"
          @onCallFunc="() => renderFunction('On Demand')"
        />
      </div>
      <!-- 3 -->
      <div>
        <CardButton
          title="Business"
          description="Custom solutions for large-scale needs"
          price="0"
          buttonText="Coming soon"
          :features="['Custom Rate Limits', 'Finetuned Models']"
          :isActive="currentButton === 'Business'"
          @onCallFunc="() => renderFunction('Business')"
        />
      </div>
    </div>
    <!-- The Underlining Table -->
    <div class="table-class">
      <h3
        style="font-size: 19px;
    font-weight: bold; margin-bottom: 0;"
      >
        {{ `${SubscriptionName} Pricing` }}
      </h3>
      <div>
        <vue-good-table
          :columns="fields"
          :rows="getAllBillingEndpoints"
          :pagination-options="{ enabled: false }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'token_price'">
              {{ "600/Call" }}
            </span>

            <span v-if="props.column.field == 'api_calls'">
              {{ "60" }}
            </span>

            <span v-if="props.column.field == 'call_cost'">
              {{ "#5,490,231" }}
            </span>

            <span v-if="props.column.field == 'data_size'">
              {{ "78,239,812" }}
            </span>
          </template>

          <template slot="pagination-bottom" slot-scope="props">
            <grey-pagination
              :total="props.total"
              :pageChanged="props.pageChanged"
              :perPageChanged="props.perPageChanged"
              @paginated-info="paginationInfo = $event"
            ></grey-pagination>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import CardButton from "@/components/pages/section-manager/layout/CardButton.vue";
//
export default {
  name: "PartnerPaymentPlatform",
  components: { CardButton },
  data() {
    return {
      SubscriptionName: "On Demand",
      api_price: "0",
      getAllBillingEndpoints: [],
      currentButton: "",
      fields: [
        {
          field: "token_price",
          label: "Token Price (#)",
          sortable: "true",
          width: "500px"
        },
        {
          field: "api_calls",
          label: "Number of Calls",
          sortable: "true"
        },
        {
          field: "call_cost",
          label: "Cost on calls (#)",
          sortable: "true"
        },
        {
          field: "data_size",
          label: "Data Size (kb)",
          sortable: "true"
        }
      ]
    };
  },
  computed: {},
  methods: {
    renderFunction(value) {
      this.currentButton = value;
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
.partner-payment-platform {
  background-color: #f8f8f8;
  color: #939daa;
}
.buttons-row {
  max-height: 65vh;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  width: 100%;
}
.content-area {
  background-color: #f5f6f8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/section-manager/PartnerPaymentPlatform.vue